import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DrmCapabilityService {

  async supportsPersistentLicense(): Promise<boolean> {
    if (!('requestMediaKeySystemAccess' in navigator)) return false;
  
    try {
      const config:any = [{
        initDataTypes: ['cenc'],
        persistentState: 'required',
        sessionTypes: ['persistent-license'],
        videoCapabilities: [{
          contentType: 'video/mp4; codecs="avc1.4d4028"',
          robustness: 'SW_SECURE_CRYPTO'   // <-- removes your warning spam
        }]
      }];
  
      const access = await navigator.requestMediaKeySystemAccess('com.widevine.alpha', config);
      return !!access;
    } catch (e) {
      return false;
    }
  }  
}